import { EChartsOption } from "echarts-for-react";
import React, { Fragment } from "react";
import { round } from "lodash";
import { ConsumptionRateSection } from "@hpo/client/models/Archive";
import EChart from "@hpo/client/utilities/Echart";
import ProgramKey, {
  ProgramKeyValues,
} from "@hpo/client/utilities/enums/ProgramKey";
import { find } from "@hpo/client/utilities/is";
import Programs from "@hpo/client/utilities/Programs";

type ConsumptionRateProps = {
  payload: ConsumptionRateSection;
};

export default function ConsumptionRate(props: ConsumptionRateProps) {
  const section = props.payload;

  return (
    <div>
      <h2>{section.title}</h2>
      {ProgramKeyValues.map((programKey) => {
        return (
          <Fragment key={programKey}>
            <h3>
              {section.title} / {Programs[programKey].label}
            </h3>
            <ConsumptionRateChart section={section} program={programKey} />
          </Fragment>
        );
      })}
    </div>
  );
}

type ConsumptionRateChartProps = {
  section: ConsumptionRateSection;
  program: ProgramKey;
};

function ConsumptionRateChart(props: ConsumptionRateChartProps) {
  const { section, program } = props;

  const programData = find(section.byProgram, (p) => p.key === program);

  const option: EChartsOption = {
    grid: {
      show: true,
    },
    xAxis: {
      type: "category",
      data: props.section.periods,
    },
    yAxis: {
      type: "value",
      min: 0,
      max: 1,
      axisLabel: { formatter: (v: number) => `${round(v * 100)} %` },
      splitLine: { show: true },
    },
    series: [
      ...programData.byOrganization.map((org) => ({
        name: org.label,
        type: "line",
        data: section.periods.map((p) => org.data[p]),
        itemStyle: { color: org.color },
        lineStyle: { color: org.color, width: 1 },
        symbol: "circle",
        symbolSize: 16,
        label: {
          show: true,
          position: "right", // Position au-dessus du point
          distance: 2,
          fontSize: 10,
          formatter: (o: any) => `${round(o.value * 100)} %`, // Affiche la valeur brute
        },
      })),
      {
        name: "Tous",
        data: section.periods.map((p) => programData.data[p]),
        type: "line",
        itemStyle: { color: "#000000" },
        lineStyle: { color: "#000000", width: 3 },
        symbol: "circle",
        symbolSize: 16,
        label: {
          show: true,
          position: "right", // Position au-dessus du point
          distance: 2,
          fontSize: 10,
          formatter: (o: any) => `${round(o.value * 100)} %`, // Affiche la valeur brute
        },
      },
    ],
  };

  return (
    <div>
      <EChart option={option} height={500} />
    </div>
  );
}
